import { jsx as o, jsxs as p } from "react/jsx-runtime";
import s from "react";
import { styled as r, css as c } from "styled-components";
import { c as g } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { D as u, R as h } from "../chunks/Description.be3b00d1.js";
import { a as l, R as x, B as I } from "../chunks/index.b09c00db.js";
import { a as b } from "../chunks/index.cff5baaf.js";
import { R as y, I as z } from "../chunks/index.5437e162.js";
const R = r.div.withConfig({
  displayName: "Host",
  componentId: "sc-1a9ztof-0"
})(["position:fixed;top:0;left:0;z-index:5;width:100%;height:100%;pointer-events:none;"]), w = r.div.withConfig({
  displayName: "Alert",
  componentId: "sc-1a9ztof-1"
})(["box-sizing:border-box;display:flex;flex-direction:row;align-items:center;gap:var(--spacing-1_5x);padding:var(--spacing-2x) var(--spacing-half) var(--spacing-2x) var(--spacing-2x);min-height:var(--size-12x);pointer-events:initial;visibility:hidden;transform:translateY(-100%);transition-property:transform,visibility;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-moderate-01);", " ", " ", ":hover{", "}"], ({
  $opened: i
}) => i && c`
      visibility: visible;
      transform: translateY(0%);
      transition-duration: var(--duration-moderate-02);
      transition-timing-function: var(--curve-productive-entrance);
    `, ({
  type: i
}) => i && c`
      background-color: var(--${i}-bg-color-02);

      ${u} {
        color: var(--on-${i}-description-color);
      }

      a {
        color: inherit;
      }

      ${l} {
        color: inherit;
        ${b} {
          color: var(--on-${i}-icon-color);
        }
      }
    `, l, g), C = r.div.withConfig({
  displayName: "Content",
  componentId: "sc-1a9ztof-2"
})(["flex:1 1 auto;"]), $ = {
  Informative: "informative",
  Positive: "positive",
  Warning: "warning",
  Negative: "negative"
}, A = {
  informative: "InformationLine",
  positive: "PositiveLine",
  negative: "NegativeLine",
  warning: "WarningLine"
}, L = s.forwardRef(({
  children: i,
  type: t = $.Informative,
  opened: n = !0,
  buttonIconAriaLabel: v,
  onOpen: a,
  onClose: e,
  ...m
}, d) => {
  s.useEffect(() => {
    a && n && a(n);
  }, [n]);
  const f = () => {
    e && e(!0);
  };
  return /* @__PURE__ */ o(R, { children: /* @__PURE__ */ p(w, { ref: d, $opened: n, type: t, role: "alert", "data-rango-component": "rango-alert", "data-is-rango": !0, ...m, children: [
    /* @__PURE__ */ o(y, { type: t, size: z.MD, icon: A[t] }),
    /* @__PURE__ */ o(C, { children: /* @__PURE__ */ o(h, { children: i }) }),
    /* @__PURE__ */ o(x, { size: I.LG, icon: "CloseLine", "aria-label": v, onClick: f })
  ] }) });
});
L.displayName = "RangoAlert";
export {
  L as RangoAlert
};
